<template>
  <nav class="nav">
    <ul class="nav-list">
      <li
        v-for="item in navItems"
        :key="item"
        :class="['nav-item', { active: item === selectedItem }]"
        @click="selectItem(item)"
        @keypress="selectItem(item)"
        tabindex="0"
      >
        {{ item }}
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import { ref, defineProps, watch } from 'vue';

const props = defineProps<{
  navItems: string[];
  selectedItem: string;
  onSelectItem:(item: string) => void;
}>();

const selectedItem = ref(props.selectedItem);

const selectItem = (item: string) => {
  selectedItem.value = item;
  props.onSelectItem(item);
};

watch(
  () => props.selectedItem,
  (newValue) => {
    selectedItem.value = newValue;
  },
);
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.nav {
  font-family: 'Montserrat';
  margin: 20px 0;

  @media (max-width: 768px) {
    width: 80%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
}

.nav-list {
  display: flex;
  gap: 1rem;
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }
}

.nav-item {
  flex: 1;
  padding: 10px 20px;
  text-align: center;
  border: 2px solid $color-border;
  border-radius: 10px;
  color: $color-border;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s;

  @media (max-width: 768px) {
    flex: none;
    width: 55vw;
  }
}

.nav-item:hover {
  background-color: rgba(202, 194, 164, 0.1);
}

.nav-item.active {
  border: 2px solid transparent;
  background-color: $color-highlight;
  color: $color-text;
}
</style>
